export const getLeadsData = state => state.leads.data
